// Minimal LRUCache stub — replaces the heavy lru-cache module pulled in by
// unleash-client's strategy.js. Only get/set/has are called at runtime.
export class LRUCache {
  private map = new Map<string, unknown>();
  get(key: string) {
    return this.map.get(key);
  }
  set(key: string, value: unknown) {
    this.map.set(key, value);
  }
  has(key: string) {
    return this.map.has(key);
  }
}
